import { render, staticRenderFns } from "./CancelMoveDepartment.vue?vue&type=template&id=a7b387f2&scoped=true"
import script from "./CancelMoveDepartment.vue?vue&type=script&lang=js"
export * from "./CancelMoveDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b387f2",
  null
  
)

export default component.exports